/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_LaunchInputs */

const en_fc_online_launch = /** @type {(inputs: Fc_Online_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch FilmCraft Online`)
};

/**
* | output |
* | --- |
* | "Launch FilmCraft Online" |
*
* @param {Fc_Online_LaunchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_launch = /** @type {((inputs?: Fc_Online_LaunchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_LaunchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_launch(inputs)
});
export { fc_online_launch as "fc.online.launch" }